
import { createNamespacedHelpers } from '@/common/vuex-composition-hooks';
import { defineComponent, onBeforeMount } from 'vue-demi';
import { IAuthActions, IAuthGetters, IAuthState } from '../login/types';
import DashboardTabsMobile from './components/DashboardTabsMobile.vue';
const Auth = createNamespacedHelpers<IAuthState, IAuthGetters, IAuthActions>(
  'auth'
);
const Dashboard = createNamespacedHelpers<
  IDashboardBrandManagementState,
  IBrandManagerActions
>('dashboardBrandManagement');
import { mapActions } from 'vuex';
import { useRoute } from 'vue-router';
import { IBrandManagerActions, IDashboardBrandManagementState } from './types';

export default defineComponent({
  components: {
    DashboardTabsMobile,
  },

  data() {
    return {
      filters: {
        maxDate: '',
        minDate: '',
        date: '',
      },
    };
  },

  computed: {
    currentFormattedDate() {
      let date = '';
      const now = new Date();
      if (this.getFilteredDateYYYYMM) {
        date = new Date(
          `${this.getFilteredDateYYYYMM}-${now.getDate()}`
        ).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
        });
      } else {
        date = new Date().toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
        });
      }

      return date;
    },
  },

  watch: {
    getFilteredDateYYYYMM: {
      handler(newValue, oldValue) {
        if (newValue === oldValue) return;
        if (
          this.route?.redirectedFrom?.fullPath !== '/dashboard' &&
          this.route.redirectedFrom?.fullPath !== '/desktop' &&
          this.route.fullPath !== '/login' &&
          this.route.fullPath !== '/dashboard-brand-management/totals'
        ) {
          this.fetchTargetAccomplishedEcomm({
            brandCodes: [this.route.meta.code],
          });
          this.fetchTargetAccomplishedExport({
            brandCodes: [this.route.meta.code],
          });
          this.fetchTargetAccomplishedDtc({
            brandCodes: [this.route.meta.code],
          });
          this.fetchTargetAccomplishedWholesale({
            brandCodes: [this.route.meta.code],
          });
        }
        if (this.route.fullPath === '/dashboard-brand-management/totals') {
          this.fetchRealizedBudgetWls();
          this.fetchRealizedBudgetDtc();
          this.fetchRealizedBudgetExport();
          this.fetchRealizedBudgetEcomm();
          this.fetchMonthTotalsWls();
          this.fetchMonthTotalsDtc();
          this.fetchMonthTotalsExport();
          this.fetchMonthTotalsEcomm();
        }
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions('auth', ['setFilteredDateYYYYMM']),
    maxDateValid() {
      const currentDate = new Date();
      const yyyy = currentDate.getFullYear().toString();
      const mm =
        currentDate.getMonth() + 1 < 10
          ? `0${(currentDate.getMonth() + 1).toString()}`
          : (currentDate.getMonth() + 1).toString();
      const formattedDate = `${yyyy}-${mm}`;
      return formattedDate;
    },
    minDateValid() {
      const currentDate = new Date();
      const yyyy = currentDate.getFullYear().toString();
      const mm =
        currentDate.getMonth() < 10
          ? `0${currentDate.getMonth().toString()}`
          : currentDate.getMonth().toString();
      const formattedDate = `${yyyy}-${mm}`;
      return formattedDate;
    },
    handlerDate(event) {
      this.setFilteredDateYYYYMM(event.target.value);
      this.filters.date = this.getFilteredDateYYYYMM;
    },
  },

  created() {
    const maxDate = this.maxDateValid();
    this.filters.maxDate = maxDate;
    const minDate = this.minDateValid();
    this.filters.minDate = minDate;
    if (this.sessionUser.filteredDateYYYYMM) {
      this.filters.date = this.sessionUser.filteredDateYYYYMM;
    } else {
      this.setFilteredDateYYYYMM(maxDate);
      this.filters.date = maxDate;
    }
  },

  setup() {
    const { billingUnit } = Auth.useState(['billingUnit']);
    const { selectedchannel } = Dashboard.useState(['selectedchannel']);
    const { sessionUser, getFilteredDateYYYYMM } = Auth.useGetters([
      'sessionUser',
      'getFilteredDateYYYYMM',
    ]);
    const {
      fetchTargetAccomplishedEcomm,
      fetchTargetAccomplishedExport,
      fetchTargetAccomplishedDtc,
      fetchTargetAccomplishedWholesale,
      changeSelectedChannel,
    } = Dashboard.useActions([
      'fetchTargetAccomplishedEcomm',
      'fetchTargetAccomplishedExport',
      'fetchTargetAccomplishedDtc',
      'fetchTargetAccomplishedWholesale',
      'changeSelectedChannel',
    ]);
    const {
      fetchRealizedBudgetWls,
      fetchRealizedBudgetDtc,
      fetchRealizedBudgetExport,
      fetchRealizedBudgetEcomm,
      fetchMonthTotalsWls,
      fetchMonthTotalsDtc,
      fetchMonthTotalsExport,
      fetchMonthTotalsEcomm,
    } = Dashboard.useActions([
      'fetchRealizedBudgetWls',
      'fetchRealizedBudgetDtc',
      'fetchRealizedBudgetExport',
      'fetchRealizedBudgetEcomm',
      'fetchMonthTotalsWls',
      'fetchMonthTotalsDtc',
      'fetchMonthTotalsExport',
      'fetchMonthTotalsEcomm',
    ]);

    const { SET_ACCESS_TYPE } = Auth.useMutations(['SET_ACCESS_TYPE']);

    const { sessionUpdate } = Auth.useActions(['sessionUpdate']);

    const route = useRoute();

    onBeforeMount(() => SET_ACCESS_TYPE('panel'));

    return {
      billingUnit,
      SET_ACCESS_TYPE,
      sessionUpdate,
      sessionUser,
      route,
      getFilteredDateYYYYMM,
      fetchTargetAccomplishedEcomm,
      fetchTargetAccomplishedExport,
      fetchTargetAccomplishedDtc,
      fetchTargetAccomplishedWholesale,
      fetchRealizedBudgetWls,
      fetchRealizedBudgetDtc,
      fetchRealizedBudgetExport,
      fetchRealizedBudgetEcomm,
      fetchMonthTotalsWls,
      fetchMonthTotalsDtc,
      fetchMonthTotalsExport,
      fetchMonthTotalsEcomm,
      changeSelectedChannel,
      selectedchannel,
    };
  },
});
